export interface SortState {
  sortBy: string | undefined;
  order: string | undefined;
}

export const initialSortState: SortState = {
  sortBy: undefined,
  order: undefined
};
